export enum OrderStatus {
  Placed = 1000,
  Scheduled = 1001,
  Routed = 1002,
  SentToPos = 1003,
  CancelledByUser = 1010,
  CancelledByUserForEdit = 1011,
  Error = 2000,
  SentToPOSError = 2101,
  PaymentProcessingError = 2102,
  SQLDatabaseError = 2103,
  DocumentDatabaseError = 2104,
  RewadServiceError = 2105,
  NetworkError = 2106,
  UnknownError = 2110,
  CancelledBySystem = 3000,
  PaymentDeclined = 3100,
  RewardUnavailable = 3101,
  OfferUnavailable = 3102,
  RecipeUnavailable = 3103,
  LTOUnavailable = 3104,
  ModifierGroupUnavailable = 3105,
  LocationClosed = 3106,
  POSMappingUnavailable = 3107,
  OrderIsReady = 3116,
  OrderWasPickedUp = 1101
}

export enum OrderTriggerType {
  Timed = 1,
  Manual = 2,
  Immediate = 3
}
